export default __webpack_public_path__ + "static/timeline-07-4d3a17ac3662d2c231857737bc63bcea.svg";